import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { BORDER, COLOR_GREY_4 } from "shared/theme/colors";
import { flex, flexColumn } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  padding-top: 1.5rem;
  ${flexColumn({ ai: "flex-start" })};
  border-right: ${BORDER(1, COLOR_GREY_4)};
  width: 328px;
  height: calc(100vh - 127px);
`;

export const StyledListContainer = styled(Box)`
  ${flexColumn({ ai: "flex-start" })};
  width: 328px;
  height: calc(100vh - 127px);
  overflow-y: auto;
`;

export const StyledLoaderContainer = styled(Box)`
  ${flexColumn({ ai: "center", jc: "center" })};
  width: 100%;
  min-height: 80px;
`;

export const StyledTicket = styled(Box)`
  width: 100%;
  border-bottom: ${BORDER(1, COLOR_GREY_4)};
`;

export const StyledEmptyContainer = styled(Box)`
  ${flex({ jc: "center", ai: "center" })};
  margin-top: 0.5rem;
  height: 51px;
  width: 100%;
`;
